import { render, staticRenderFns } from "./role-change.vue?vue&type=template&id=2953cc24&scoped=true&"
import script from "./role-change.vue?vue&type=script&lang=js&"
export * from "./role-change.vue?vue&type=script&lang=js&"
import style0 from "./role-change.vue?vue&type=style&index=0&id=2953cc24&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2953cc24",
  null
  
)

export default component.exports